import { AnalyzeConstants } from '../../../src/_constants/Analyze/analyze.constants';

const initialState = { getCompetencyLoading: true, data: '', errorResponse: '', error: false };

export function competencyReducer(state = initialState, action) {

    switch (action.type) {
        case AnalyzeConstants.REQUEST_COMPETENCY:
            return {
                getCompetencyLoading: true,
                data: '',
                errorResponse: '',
                error: false
            };
        case AnalyzeConstants.RECEIVE_COMPETENCY:
            return {
                getCompetencyLoading: false,
                data: action.res,
                errorResponse: '',
                error: false
            };
        case AnalyzeConstants.ERROR_COMPETENCY:
            return {
                getCompetencyLoading: false,
                data: '',
                errorResponse: action.error.response.data.message ? action.error.response.data.message : 'Error Occured!',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyze/competency.reducer.js